import ManualFileUpload from './ManualFileUpload';
import CommonManualFileUpload from './CommonManualFileUpload';
import InstantUpload from './InstantUpload';

export {
  ManualFileUpload,
  CommonManualFileUpload,
  InstantUpload,
};



// WEBPACK FOOTER //
// ./src/components/ui/FileUploads/index.js